'use client'

import { useIsMobileBreakpoint } from '@chaseweb/utils/useIsMobileBreakpoint'
import { useEffect, useState } from 'react'

export const useMobileNavigationRootHook = () => {
  const isMobile = useIsMobileBreakpoint()
  const [isSideMenuOpen, setIsSideMenuOpen] = useState<boolean | undefined>(
    undefined,
  )

  useEffect(() => {
    const handleResize = () => {
      setIsSideMenuOpen(false)
    }
    setIsSideMenuOpen(false)
    window.addEventListener('resize', handleResize, false)
    return () => {
      window.removeEventListener('resize', handleResize, false)
    }
  }, [])

  return [isMobile, isSideMenuOpen, setIsSideMenuOpen] as const
}
